import React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import AutoCompleteItem from './AutoCompleteItem';
import classes from './AutoCompleteStyles';
export default function AutoComplete(props) {
    const { acData, selectedIndex, handleSubmit, handleAutocompleteItemSelect, } = props;
    const items = Object.keys(acData.data).map((key, i) => (React.createElement(AutoCompleteItem, { key: key, index: i, query: acData.query, isFirst: acData.data[key].first, queryType: acData.data[key].type, queryLabel: acData.suggestions[key], submitQuery: handleSubmit, handleAutocompleteItemSelect: handleAutocompleteItemSelect, isSelected: selectedIndex === i })));
    return (React.createElement(Grid, { sx: classes.searchAutoComplete },
        React.createElement(List, null, items)));
}
